import {
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  Tooltip,
  useTheme,
  useMediaQuery
} from '@material-ui/core'
import clsx from 'clsx'

import { Button } from '.'

import useStyles from './styles'

export const Dialog = ({
  title,
  actionButtons,
  actionStart,
  children,
  dialogStyleProps = {},
  contentStyleProps = {},
  classNameActionButton,
  ...props }) => {
  const classes = useStyles()
  // callers build the list with conditional entries (`cond ? { … } : undefined`), which are skipped
  const buttons = (actionButtons || []).filter(Boolean)

  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))

  let defaultDialogStyle = {}
  let defaultContentStyle = {}

  if (smDown) {
    defaultContentStyle = {
      root: classes.dialogContentSmall
    }
    defaultDialogStyle = {
      paperFullWidth: classes.dialogWrapperSmall,
      paper: classes.dialogMarginSmall
    }
  }

  return (
    <MuiDialog
      {...props}
      indicatorColor='primary'
      classes={{
        root: classes.dialog,
        ...defaultDialogStyle,
        ...dialogStyleProps,
      }}
      minWidth="sm"
      fullWidth
    >
      {title &&
        <MuiDialogTitle classes={{root: classes.dialogTitle}}>{title}</MuiDialogTitle>
      }
      <MuiDialogContent
        classes={{
          ...defaultContentStyle,
          ...contentStyleProps
        }}
      >
        {children}
      </MuiDialogContent>
      {(buttons.length > 0 || actionStart) &&
        <MuiDialogActions className={clsx(classNameActionButton)}>
          {/* Optional left side of the footer (e.g. a summary), vertically centered with the buttons */}
          {actionStart && <div style={{ marginRight: 'auto', minWidth: 0, padding: '0 8px' }}>{actionStart}</div>}
          {buttons.map(({ tooltip, ...btn }, index) => (
            // Opt-in `tooltip` — wrapped in a <span> so the tooltip still shows over a
            // disabled button (MUI Tooltip can't listen on a disabled child directly).
            tooltip
              ? <Tooltip key={index} title={tooltip}><span><Button {...btn} /></span></Tooltip>
              : <Button key={index} {...btn} />
          ))
          }
        </MuiDialogActions>
      }
    </MuiDialog>
  )
}

export default Dialog